<form [formGroup]="form" (ngSubmit)="$event.preventDefault()">
    <div class="row">
        <div class="col-md-3">
            <div class="header-wrapper">
                <fieldset>
                    <label>
                        Handelssortiment används för
                    </label>
                </fieldset>
            </div>
            <div class="checkboxes">
                <rask-checkbox
                    aid="produktionJa"
                    text="Produktion"
                    formControlName="forProduktion"></rask-checkbox>
                <rask-checkbox
                    aid="produktionJa"
                    text="Inmätning"
                    (checkedChange)="inmatningCheckedChanged($event)"
                    formControlName="forInmatning"></rask-checkbox>
            </div>
        </div>
        <div class="col-md-3">
            <rask-selector
                infoText="Inmätning"
                class="col-12" label="ViolId"
                formControlName="viol3HandelssortimentInfo"
                [reverseLookup]="false"
                [formatter]="violOutputFormatter"
                [viewSelectedFormatter]="violSelectedFormatter"
                placeholder="Ange minst tre tecken"
                [getSelectionFromModel]="getInitSelectedViolId"
                [search]="searchForViolId" [viewFormatter]="violFormatter">
            </rask-selector>
        </div>
        <div class="col-md-3">
            <rask-selector
                infoText="Handelssortiment för inmätning"
                class="col-12" label="Huvudhandelssortiment för inmätning"
                formControlName="inmatningshandelssortimentId"
                [formatter]="handelssortimentOutputFormatter"
                placeholder="Ange minst tre tecken"
                [getSelectionFromModel]="getInitSelectedHandelssortiment"
                [raskDisabledControl]="handelssortiment.forInmatning"
                [exclude]="[handelssortiment]"
                [search]="searchForHandelssortiment" [viewFormatter]="handelssortimentFormatter">
            </rask-selector>
        </div>
    </div>
</form>
